import ApplicationAdapter from './application';

export default class SignInFieldActionRuleGroupAdapter extends ApplicationAdapter {
  pathForType() {
    return 'sign-in-field-action-rule-groups';
  }
}
